import React from 'react'
import styled from 'styled-components';

const Container = styled.div`
    position: relative;
    width: 185px;
    height: 185px;
    border-radius: 5px;
    overflow: hidden;
    margin-bottom: 30px;
    align-self: center;
    box-shadow: 0px 3px 6px #00000015;
		margin-top: 15px;
		
		:hover > a {
			bottom: 0;
		}
`;
const Cover = styled.img`
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 100%;
    margin: 0;
    z-index: 0;
`;
const Gradient = styled.div`
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 100%;
    background: rgb(0,0,0);
    background: linear-gradient(0deg, rgba(0,0,0,1) 0%, rgba(0,0,0,0) 100%);
    z-index: 1;
`;
const Name = styled.h3`
    z-index: 2;
    position: absolute;
    bottom: 10px;
    color: white;
    font-size: 16px;
    width: 100%;
    padding: 0 10px;
    text-align: center;
    margin: 0 0 5px 0;
  
`;

const ViewDemo = styled.a`
position: absolute;
bottom: -25%;
margin: 0;
width: 100%;
height: 25%;
background-color: #000;
border: none;
color: #fff;
z-index: 100;
font-size: 16px;
line-height: 1.2%;
display: flex;
justify-content: center;
align-items: center;
cursor: pointer;
transition: all 0.3s ease-in-out;
`;

const TemplateItem = ({ name, imgSrc, url }) => (
    <Container >
        <Cover src={imgSrc} />
        <Gradient />
        <Name>{name}</Name>
				<ViewDemo href={url} target="_blank">View Demo</ViewDemo>
    </Container>
)

export default TemplateItem